
export interface ReadingStats {
  wordsRead: number;
  timeSpentSeconds: number;
  lastWpm: number;
  maxWpm: number; // Global max speed achieved
  avgWpm: number; // Global average speed
  sessions: number;
  history: SessionResult[]; // Array of past session results
  // NEW fields for achievements:
  booksCompleted: number;         // Count of fully completed books
  genresRead: string[];           // Category IDs read
  sourcesRead: string[];          // Book/source IDs
  formatsRead: string[];          // File extensions (txt, epub, pdf, etc.)
  timeOfDaySessions: {
    morning: number;   // 5-11
    afternoon: number; // 11-17
    evening: number;   // 17-21
    night: number;     // 21-5
  };
  // Phase 1 & 2 additions:
  challengesCompleted: number;    // Total daily challenges completed
  perfectDaysCount: number;       // Number of days all 3 challenges were completed
  peakDailyWords: number;         // Highest single-day word count
  achievementsUnlocked: number;   // Count of unlocked achievements
   // Phase 3 additions (optional for backward compatibility):
   highWpmStreak?: number;          // Consecutive days with avg WPM ≥ 400
   streakMultiplier?: number;       // Derived: 1 + floor(highWpmStreak / 5), capped at 10
   lastActiveDate?: string;         // Last date (YYYY-MM-DD) user had a reading session
   longestStreak?: number;          // Longest streak achieved (consecutive days)
   newRecord?: boolean;             // Flag: current streak just beat longestStreak
   streakRecovery?: boolean;        // Flag: recovered streak after 1-day gap
   streakBounceBack?: boolean;      // Flag: started new streak after 7+ day gap
   // Phase 4 additions: time aggregates for daily/weekly/monthly achievements
   todaySeconds?: number;           // Seconds read today (current day)
   todayWords?: number;             // Words read today (current day)
   weekSeconds?: number;            // Seconds read in current week (rolling 7 days)
   monthSeconds?: number;           // Seconds read in current month (rolling 30 days)
}

export interface SessionResult {
  wordsRead: number;
  durationSeconds: number;
  avgWpm: number;
  maxWpm: number;
  date: string;
  bookId?: string;        // Optional book identifier for per-book progress tracking
  chapterId?: string;     // Optional chapter identifier for per-chapter progress
  startWordIndex?: number; // Word index at session start (for resume tracking)
  // NEW fields:
  accuracy?: number;      // Accuracy percentage (0-100), default 100
  paused: boolean;        // Whether session was paused at any point
  format?: string;        // File format of content (txt, epub, pdf, etc.)
}

export interface UserProfile {
  name: string;
  stats: ReadingStats;
  currentWpm: number;
  theme: 'light' | 'dark';
}

export enum ReaderStatus {
  IDLE = 'IDLE',
  PLAYING = 'PLAYING',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED'
}

export interface AuthState {
  isAuthenticated: boolean;
  user?: {
    name: string;
  };
}
